export function hasValue<T> (v: T | undefined | null): v is T {
  return (v !== null && v !== undefined)
}

export const getIn = (object: any, ...path: any): any => {
  return path.reduce((obj: any, element: any) => obj?.[element], object)
}
